import { render, staticRenderFns } from "./SubRowMobile.vue?vue&type=template&id=12fd6d95&scoped=true&"
import script from "./SubRowMobile.vue?vue&type=script&lang=ts&"
export * from "./SubRowMobile.vue?vue&type=script&lang=ts&"
import style0 from "./SubRowMobile.vue?vue&type=style&index=0&id=12fd6d95&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fd6d95",
  null
  
)

export default component.exports